import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Gossip from "./components/Gossip";
import RankAndPicks from "./components/RankAndPicks";
import Guide from "./components/Guide";
import ReviewsFaq from "./components/ReviewsFaq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <Gossip />
      <RankAndPicks />
      <Guide />
      <ReviewsFaq />
      <Subscribe />
      <Footer />
      <BackToTop />
    </main>
  );
}